exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confessionItem[data-v-73548fe2]{min-height:300px;width:300px;background:#fafad2;border-radius:5px;padding:10px;margin:10px}.confessionText[data-v-73548fe2]{min-height:200px;font-size:15px;font-family:Roboto,sans-serif;display:flex;align-items:center;justify-content:center;text-align:center;word-wrap:break-word}.metaItem[data-v-73548fe2]{display:flex;align-items:center;padding:10px}.metaText[data-v-73548fe2]{position:relative;font-family:Roboto,sans-serif;top:-1px;left:10px}.comment[data-v-73548fe2]{position:relative;top:-1px}.tagContainer[data-v-73548fe2]{flex-wrap:wrap}.tag[data-v-73548fe2],.tagContainer[data-v-73548fe2]{display:flex;justify-content:center;align-items:center}.tag[data-v-73548fe2]{min-width:50px;padding:10px;background:#90ee90;margin:3px;border-radius:10px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73548fe2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Dynamic/app/blog/comps/confessionitem.vue
// module id = 601
// module chunks = 0